<div class="wrapper" [ngClass]="{'active': value}">
  <span class="indicator"></span>
</div>
